import React from 'react';
import { Form, Select } from 'antd';
import { FormField } from '../../../interfaces/FormInterfaces';
import allowClearConfig from '../../common/common-functions/commonApiUrl/allowClear';

const AntdSelect = (props: FormField) => {
  return (
    <Form.Item
      name={props.name}
      rules={props.rules}
      initialValue={props.initialValue}
    >
      <Select
        {...props.otherprops}
        {...props}
        allowClear={allowClearConfig}
        className={`${props?.className ?? props?.otherprops?.className ?? ''} custom-select`}
      />
    </Form.Item>
  );
};

export default AntdSelect;
